import React from 'react';
import { useParams, Link } from 'react-router-dom';
import HeroSection from '../components/HeroSection';
import SectionTitle from '../components/SectionTitle';
import { CheckIcon, AwardIcon } from 'lucide-react';
const CaseDetail = () => {
  const {
    category,
    id
  } = useParams<{
    category: string;
    id: string;
  }>();
  const cases = {
    llm: {
      title: '大模型服务应用案例',
      cases: {
        case1: {
          title: '金融行业智能风控系统',
          subtitle: '为某大型银行构建基于大模型的智能风控系统，提高风险识别准确率40%，减少人工审核时间60%',
          client: '某国有大型商业银行',
          industry: '金融行业',
          challenge: `该银行面临着日益复杂的金融欺诈和风险场景，传统的规则引擎和简单机器学习模型已难以应对。主要挑战包括：
1. 欺诈手段不断翻新，规则引擎难以及时更新
2. 大量的误报导致人工审核压力大，客户体验受影响
3. 跨部门数据孤岛，难以形成全面的风险视图
4. 风险决策缺乏可解释性，难以满足合规要求`,
          solution: `我们基于PH8大模型平台，为客户构建了一套智能风控系统：
1. 部署了经过金融领域数据微调的大模型，提升对金融风险的识别能力
2. 开发了多模态数据融合分析模块，整合交易、客户行为、外部风险情报等多源数据
3. 构建了风险决策解释系统，提供详细的风险判断依据
4. 设计了持续学习机制，系统可从新出现的欺诈模式中学习并更新`,
          results: ['风险识别准确率提高40%，显著降低欺诈损失', '误报率降低50%，减少人工审核时间60%', '客户体验提升，交易审核时间缩短80%', '系统可解释性满足监管要求，合规风险降低', '能够快速应对新型欺诈手段，系统持续进化'],
          technologies: ['PH8大模型平台', '金融领域微调模型', '多模态数据融合技术', '可解释AI技术', '持续学习框架'],
          testimonial: {
            content: '与贵公司合作是我们数字化转型的重要一步。PH8大模型平台帮助我们实现了智能风控系统的升级，不仅提高了风险识别的准确性，还大幅减少了人工审核时间。专业的技术团队和优质的服务让我们的合作非常愉快。',
            author: '张总',
            position: '风控部门负责人'
          },
          image: 'https://images.unsplash.com/photo-1601597111158-2fceff292cdc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
        },
        case2: {
          title: '智能客服升级项目',
          subtitle: '帮助某电商平台升级智能客服系统，接入大模型能力，提升复杂问题解决率35%，客户满意度提升25%',
          client: '某知名电商平台',
          industry: '电子商务',
          challenge: `该电商平台每天面临海量的客服咨询，传统的基于规则和简单模型的智能客服系统面临以下挑战：
1. 对复杂、多轮对话的理解能力有限，无法有效解决非标准问题
2. 缺乏上下文理解能力，用户体验不佳
3. 知识库更新维护成本高，难以及时响应新产品和政策变化
4. 高峰期人工客服压力大，响应时间长`,
          solution: `我们基于PH8大模型平台，为客户打造了新一代智能客服系统：
1. 接入了经过电商领域数据微调的大模型，提升对复杂问题的理解和解决能力
2. 开发了多轮对话管理模块，增强上下文理解和记忆能力
3. 构建了自动知识提取和更新机制，系统可从产品手册、政策文档等自动学习
4. 设计了人机协作流程，复杂问题智能转接人工并提供辅助信息`,
          results: ['复杂问题解决率提升35%，减少转人工率40%', '客户满意度提升25%，NPS分数提高15分', '客服人员效率提升50%，平均处理时间缩短45%', '知识库维护成本降低60%，更新速度提高3倍', '系统支持7×24小时服务，高峰期处理能力提升300%'],
          technologies: ['PH8大模型平台', '电商领域微调模型', '多轮对话管理系统', '自动知识提取技术', '人机协作框架'],
          testimonial: {
            content: '新一代智能客服系统极大地提升了我们的客户服务能力。系统对复杂问题的理解和解决能力令人印象深刻，显著提高了客户满意度。同时，它也减轻了我们客服团队的压力，让他们可以专注于更有价值的工作。',
            author: '刘经理',
            position: '客户服务中心总监'
          },
          image: 'https://images.unsplash.com/photo-1549923746-c502d488b3ea?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2071&q=80'
        },
        case3: {
          title: '法律文档智能分析系统',
          subtitle: '为某律师事务所开发法律文档智能分析系统，自动提取关键信息和风险点，提高工作效率50%以上',
          client: '某大型律师事务所',
          industry: '法律服务',
          challenge: `该律师事务所每天需要处理大量复杂的法律文档，面临以下挑战：
1. 文档审阅耗时耗力，高级律师时间成本高昂
2. 关键条款和风险点可能被遗漏，带来法律风险
3. 不同律师的审阅标准和经验不同，导致结果不一致
4. 知识沉淀和共享效率低，难以充分利用历史经验`,
          solution: `我们基于PH8大模型平台，为客户开发了法律文档智能分析系统：
1. 部署了经过法律领域数据训练的专业大模型，提升对法律语言的理解能力
2. 开发了文档结构化分析模块，自动识别文档类型和结构
3. 构建了关键条款提取和风险点识别功能，并提供相关法规和案例参考
4. 设计了知识库积累机制，系统可从历史案例中持续学习`,
          results: ['文档审阅时间减少60%，大幅提高工作效率', '关键条款和风险点识别准确率达90%以上', '律师可专注于高价值判断和决策，提高服务质量', '初级律师能力提升，培训周期缩短50%', '知识沉淀和共享效率提高，形成良性循环'],
          technologies: ['PH8大模型平台', '法律领域专业模型', '文档结构化分析技术', '风险点识别算法', '法律知识图谱'],
          testimonial: {
            content: '法律文档智能分析系统极大地提高了我们的工作效率。系统能够准确识别合同中的关键条款和潜在风险点，为律师提供有价值的参考。这不仅节省了我们的时间，还提高了服务质量和一致性。',
            author: '陈律师',
            position: '合伙人'
          },
          image: 'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2012&q=80'
        }
      }
    },
    computing: {
      title: '异构算力综合服务案例',
      cases: {
        case1: {
          title: '大规模AI模型训练平台',
          subtitle: '为某研究机构提供大规模分布式训练平台，支持千亿参数模型训练，训练速度提升3倍',
          client: '某国家级人工智能研究机构',
          industry: '科研教育',
          challenge: `该研究机构致力于大规模AI模型的研发，在训练过程中面临以下挑战：
1. 训练大规模模型需要海量算力，单机无法满足需求
2. 现有集群架构效率低下，资源利用率不足50%
3. 不同类型的训练任务对算力需求各异，难以统一管理
4. 训练过程中的故障恢复和数据同步问题频发
5. 研究人员缺乏高效的开发和调试工具`,
          solution: `我们基于普华云异构算力服务平台，为客户构建了大规模分布式训练平台：
1. 部署了包含多种国产和进口GPU的异构计算集群，总算力超过5 EFLOPS
2. 开发了智能资源调度系统，根据任务特性自动分配最优算力资源
3. 实现了高效的分布式训练框架，支持模型并行、数据并行和混合并行策略
4. 构建了容错机制和检查点系统，保障长时间训练的稳定性
5. 提供了一站式开发环境，简化模型开发和调试流程`,
          results: ['成功训练千亿参数级大模型，训练速度提升3倍', '集群资源利用率提高到85%以上，大幅降低成本', '研究人员开发效率提升200%，加速科研进展', '系统稳定性显著提升，长时间训练成功率达99%', '支持多团队并行研发，资源共享和协作效率提高'],
          technologies: ['普华云异构算力服务平台', '智能资源调度系统', '高性能分布式训练框架', '容错和检查点机制', '一站式开发环境'],
          testimonial: {
            content: '普华云异构算力平台为我们提供了强大的计算支持，使我们能够高效训练和部署大规模AI模型。平台的稳定性和性能表现令人印象深刻，技术团队的专业支持也帮助我们解决了许多挑战。',
            author: '李教授',
            position: 'AI研究中心主任'
          },
          image: 'https://images.unsplash.com/photo-1581093450021-a7e9e5e3df6f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
        }
      }
    },
    'all-in-one': {
      title: '一体机服务应用案例',
      cases: {
        case1: {
          title: '医疗影像智能诊断系统',
          subtitle: '为某三甲医院提供医疗影像AI辅助诊断系统，准确率达95%以上，大幅提升诊断效率和准确性',
          client: '某省级三甲医院',
          industry: '医疗健康',
          challenge: `该医院放射科每天需要处理大量医疗影像，面临以下挑战：
1. 医生工作负担重，影像诊断耗时且易疲劳
2. 基层医院专业放射科医生不足，诊断质量参差不齐
3. 罕见病例诊断经验缺乏，容易漏诊
4. 传统IT系统复杂，部署和维护成本高
5. 医疗数据安全和隐私保护要求严格`,
          solution: `我们基于智能办公一体机解决方案，为客户开发了医疗影像AI辅助诊断系统：
1. 部署了经过大量医疗影像训练的专业AI模型，支持CT、MRI、X光等多种影像类型
2. 开发了病灶自动检测和分类功能，提供详细的诊断建议
3. 实现了与医院PACS和HIS系统的无缝集成
4. 采用一体机部署方式，数据本地处理，确保数据安全
5. 构建了医生反馈机制，系统可从专家诊断中持续学习`,
          results: ['诊断辅助准确率达95%以上，显著提高诊断质量', '医生诊断效率提升60%，每日可处理更多病例', '降低漏诊率30%，提高患者安全性', '基层医院诊断能力提升，促进分级诊疗', '部署和维护成本降低50%，IT压力大幅减轻'],
          technologies: ['智能办公一体机解决方案', '医疗影像AI模型', '病灶检测算法', '医疗系统集成接口', '持续学习框架'],
          testimonial: {
            content: '医疗影像AI辅助诊断系统的部署大大提升了我院的诊断效率和准确性。一体机的设计使我们能够快速部署和使用系统，无需复杂的IT基础设施改造。这是我们医疗数字化转型的重要一步。',
            author: '王主任',
            position: '放射科主任'
          },
          image: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
        }
      }
    },
    'chip-testing': {
      title: 'AI芯片性能测试案例',
      cases: {
        case1: {
          title: '国产AI芯片性能评估项目',
          subtitle: '为某芯片厂商提供全面的性能测试和优化服务，帮助其产品在特定场景下性能提升35%',
          client: '某国产AI芯片厂商',
          industry: '半导体/芯片',
          challenge: `该芯片厂商开发了新一代AI加速芯片，在市场推广过程中面临以下挑战：
1. 缺乏与国际主流芯片的客观性能对比数据
2. 在实际应用场景中性能表现不稳定，与理论指标有差距
3. 软件生态不完善，主流框架适配度不高
4. 客户对产品性能存疑，市场推广困难
5. 优化方向不明确，研发资源分配效率低`,
          solution: `我们基于国产化AI芯片性能测试解决方案，为客户提供了全面的评估和优化服务：
1. 设计了全面的测试指标体系和标准化测试流程
2. 进行了与主流国际芯片的对比测试，覆盖计算性能、能耗效率、精度等维度
3. 针对多种实际应用场景进行了深入测试和性能分析
4. 发现性能瓶颈并提供了详细的优化建议
5. 协助优化了软件栈和算子库，提升框架兼容性`,
          results: ['全面掌握产品性能数据，形成客观评估报告', '针对特定场景优化后，性能提升35%', '软件生态兼容性提高，支持主流框架和模型', '明确了下一代产品的优化方向', '加速了市场推广，获得多家客户认可'],
          technologies: ['国产化AI芯片性能测试解决方案', '标准化测试流程', '性能分析工具', '算子优化技术', '软件栈适配方案'],
          testimonial: {
            content: '贵公司提供的芯片性能测试和优化服务非常专业。通过全面的测试和深入的分析，我们清楚地了解了产品的优势和不足，并有针对性地进行了优化。这对我们的产品迭代和市场推广都起到了关键作用。',
            author: '赵总',
            position: '产品总监'
          },
          image: 'https://images.unsplash.com/photo-1591405351990-4726e331f141?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
        },
        case2: {
          title: '边缘AI部署优化项目',
          subtitle: '帮助某安防设备厂商优化AI模型在国产边缘芯片上的部署，降低功耗50%，提高推理速度3倍',
          client: '某安防设备制造商',
          industry: '安防/物联网',
          challenge: `该安防设备厂商在开发新一代智能摄像头产品时，面临以下挑战：
1. 需要在功耗和成本受限的边缘设备上运行复杂AI模型
2. 国产边缘AI芯片性能发挥不充分，模型运行缓慢
3. 现有模型体积大，精度和速度难以平衡
4. 缺乏针对特定芯片的优化经验和工具
5. 产品上市时间紧迫，开发资源有限`,
          solution: `我们基于国产AI芯片性能测试解决方案，为客户提供了边缘AI部署优化服务：
1. 对目标国产边缘AI芯片进行了详细的性能特性分析
2. 设计了模型压缩和量化方案，在保持精度的前提下减小模型体积
3. 开发了针对特定芯片的算子优化库，提高计算效率
4. 实现了模型分层加载和缓存机制，优化内存使用
5. 提供了完整的部署工具链，简化生产环境部署流程`,
          results: ['模型在目标芯片上推理速度提高3倍，满足实时性要求', '设备功耗降低50%，延长电池寿命', '模型体积减小70%，内存占用大幅降低', '检测精度保持在原有水平，满足产品要求', '提前完成产品开发，加速市场投放'],
          technologies: ['国产化AI芯片性能测试解决方案', '模型压缩和量化技术', '算子优化库', '内存优化策略', '边缘部署工具链'],
          testimonial: {
            content: '通过贵公司的优化服务，我们的产品性能得到了质的飞跃。原本认为难以在国产边缘芯片上流畅运行的AI模型，现在不仅运行速度快了3倍，而且功耗只有原来的一半。这为我们的产品带来了显著的竞争优势。',
            author: '林工',
            position: '研发经理'
          },
          image: 'https://images.unsplash.com/photo-1563770660941-10a63607692e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2070&q=80'
        }
      }
    }
  };
  const categoryData = category ? cases[category as keyof typeof cases] : null;
  const caseData = categoryData && id ? categoryData.cases[id as keyof typeof categoryData.cases] : null;
  if (!categoryData || !caseData) {
    return <div className="min-h-screen flex items-center justify-center" data-id="element-341">
        <div className="text-center" data-id="element-342">
          <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-343">案例不存在</h2>
          <p className="text-gray-600 mb-6" data-id="element-344">您查找的案例不存在或已被移除。</p>
          <Link to="/cases" className="inline-block bg-primary-600 hover:bg-primary-700 text-white font-medium py-2 px-6 rounded-md transition duration-300" data-id="element-345">
            返回案例列表
          </Link>
        </div>
      </div>;
  }
  return <div className="bg-white" data-id="element-346">
      <HeroSection title={caseData.title} subtitle={caseData.subtitle} backgroundImage={caseData.image} size="medium" data-id="element-347" />
      <section className="py-16 md:py-24" data-id="element-348">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-349">
          <div className="flex flex-col lg:flex-row gap-12" data-id="element-350">
            <div className="w-full lg:w-2/3" data-id="element-351">
              <div className="mb-12" data-id="element-352">
                <SectionTitle title="客户概况" alignment="left" titleSize="medium" data-id="element-353" />
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-354">
                  <div className="bg-gray-50 p-6 rounded-lg" data-id="element-355">
                    <h3 className="text-lg font-semibold text-gray-700 mb-2" data-id="element-356">
                      客户
                    </h3>
                    <p className="text-xl text-gray-900" data-id="element-357">{caseData.client}</p>
                  </div>
                  <div className="bg-gray-50 p-6 rounded-lg" data-id="element-358">
                    <h3 className="text-lg font-semibold text-gray-700 mb-2" data-id="element-359">
                      行业
                    </h3>
                    <p className="text-xl text-gray-900" data-id="element-360">{caseData.industry}</p>
                  </div>
                </div>
              </div>
              <div className="mb-12" data-id="element-361">
                <SectionTitle title="挑战" alignment="left" titleSize="medium" data-id="element-362" />
                <div className="prose prose-lg max-w-none" data-id="element-363">
                  {caseData.challenge.split('\n\n').map((paragraph, index) => <p key={index} className="mb-4 text-gray-700" data-id="element-364">
                      {paragraph}
                    </p>)}
                </div>
              </div>
              <div className="mb-12" data-id="element-365">
                <SectionTitle title="解决方案" alignment="left" titleSize="medium" data-id="element-366" />
                <div className="prose prose-lg max-w-none" data-id="element-367">
                  {caseData.solution.split('\n\n').map((paragraph, index) => <p key={index} className="mb-4 text-gray-700" data-id="element-368">
                      {paragraph}
                    </p>)}
                </div>
              </div>
              <div className="mb-12" data-id="element-369">
                <SectionTitle title="成果" alignment="left" titleSize="medium" data-id="element-370" />
                <div className="bg-gray-50 p-6 rounded-lg" data-id="element-371">
                  <ul className="space-y-3" data-id="element-372">
                    {caseData.results.map((result, index) => <li key={index} className="flex items-start" data-id="element-373">
                        <CheckIcon className="h-5 w-5 text-primary-500 mt-0.5 mr-2 flex-shrink-0" data-id="element-374" />
                        <span className="text-gray-700" data-id="element-375">{result}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
              {caseData.testimonial && <div className="mb-12" data-id="element-376">
                  <SectionTitle title="客户评价" alignment="left" titleSize="medium" data-id="element-377" />
                  <div className="bg-primary-50 p-8 rounded-lg border-l-4 border-primary-500" data-id="element-378">
                    <div className="relative" data-id="element-379">
                      <svg className="absolute top-0 left-0 transform -translate-x-4 -translate-y-4 h-12 w-12 text-primary-200" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-380">
                        <path d="M7.39762 10.3C7.39762 11.0733 7.14888 11.7 6.6514 12.18C6.15392 12.6333 5.52552 12.86 4.76621 12.86C3.84979 12.86 3.09047 12.5533 2.48825 11.94C1.91222 11.3266 1.62421 10.4467 1.62421 9.29999C1.62421 8.07332 1.96459 6.87332 2.64535 5.69999C3.35231 4.49999 4.33418 3.55332 5.59098 2.85999L6.4943 4.25999C5.81354 4.73999 5.26369 5.27332 4.84476 5.85999C4.45201 6.44666 4.19017 7.12666 4.05926 7.89999C4.29491 7.79332 4.56983 7.73999 4.88403 7.73999C5.61716 7.73999 6.21938 7.97999 6.68996 8.45999C7.16054 8.93999 7.39762 9.55333 7.39762 10.3ZM14.6242 10.3C14.6242 11.0733 14.3755 11.7 13.878 12.18C13.3805 12.6333 12.7521 12.86 11.9928 12.86C11.0764 12.86 10.3171 12.5533 9.71484 11.94C9.13881 11.3266 8.85079 10.4467 8.85079 9.29999C8.85079 8.07332 9.19117 6.87332 9.87194 5.69999C10.5789 4.49999 11.5608 3.55332 12.8176 2.85999L13.7209 4.25999C13.0401 4.73999 12.4903 5.27332 12.0713 5.85999C11.6786 6.44666 11.4168 7.12666 11.2858 7.89999C11.5215 7.79332 11.7964 7.73999 12.1106 7.73999C12.8437 7.73999 13.446 7.97999 13.9166 8.45999C14.3872 8.93999 14.6242 9.55333 14.6242 10.3Z" fill="currentColor" data-id="element-381" />
                      </svg>
                      <div className="relative z-10" data-id="element-382">
                        <p className="text-lg text-gray-700 italic mb-4" data-id="element-383">
                          {caseData.testimonial.content}
                        </p>
                        <div className="font-medium text-gray-900" data-id="element-384">
                          {caseData.testimonial.author} |{' '}
                          {caseData.testimonial.position}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>}
            </div>
            <div className="w-full lg:w-1/3" data-id="element-385">
              <div className="bg-gray-50 p-6 rounded-lg sticky top-24" data-id="element-386">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-387">
                  <AwardIcon className="mr-2 h-6 w-6 text-primary-500" data-id="element-388" />
                  技术亮点
                </h3>
                <div className="space-y-4" data-id="element-389">
                  {caseData.technologies.map((tech, index) => <div key={index} className="bg-white p-4 rounded-md border-l-4 border-primary-500" data-id="element-390">
                      <span className="text-gray-900" data-id="element-391">{tech}</span>
                    </div>)}
                </div>
                <div className="mt-8" data-id="element-392">
                  <Link to="/about/contact" className="inline-block w-full bg-primary-600 hover:bg-primary-700 text-white font-medium py-3 px-6 rounded-md text-center transition duration-300" data-id="element-393">
                    咨询类似方案
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="py-16 md:py-24 bg-gray-50" data-id="element-394">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-395">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6" data-id="element-396">
            您的成功故事将会是下一个
          </h2>
          <p className="text-xl text-gray-600 mb-8 max-w-3xl mx-auto" data-id="element-397">
            无论您的业务需求是什么，我们的专业团队都将为您提供最适合的AI解决方案，帮助您实现业务目标。
          </p>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-4" data-id="element-398">
            <Link to="/about/contact" className="inline-block bg-primary-600 hover:bg-primary-700 text-white font-medium py-3 px-8 rounded-md transition duration-300" data-id="element-399">
              联系我们
            </Link>
            <Link to="/cases" className="inline-block bg-white text-primary-600 font-medium py-3 px-8 rounded-md border border-primary-600 transition duration-300 hover:bg-primary-50" data-id="element-400">
              返回案例列表
            </Link>
          </div>
        </div>
      </section>
    </div>;
};
export default CaseDetail;